import React from 'react'
import PropTypes from 'prop-types'
/* --------------------------------------------- */
const DropDownCircle = ({ color, ...rest }) => (
  <svg xmlns='http://www.w3.org/2000/svg'  viewBox="0 0 22 22"  {...rest}>
     <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Details-Content-Show---More" transform="translate(-103.000000, -487.000000)" stroke={color}>
            <g id="Group-5" transform="translate(20.000000, 488.000000)">
                <g id="Group-6" transform="translate(84.000000, 0.000000)">
                    <polyline id="Stroke-4" strokeLinecap="round" strokeLinejoin="round" points="6.1058 9.0526 10.0008 12.9476 13.8938 9.0526"></polyline>
                    <path d="M10.0004,-0.0002 C4.4774,-0.0002 0.0004,4.4778 0.0004,9.9998 C0.0004,15.5228 4.4774,19.9998 10.0004,19.9998 C15.5224,19.9998 20.0004,15.5228 20.0004,9.9998 C20.0004,4.4778 15.5224,-0.0002 10.0004,-0.0002" id="Path"></path>
                </g>
            </g>
        </g>
    </g>
  </svg>
)
/* --------------------------------------------- */
DropDownCircle.propTypes = {
  /** Color of icon. */
  color: PropTypes.string,
  /** Icon css styles. */
  style: PropTypes.object
}
/* --------------------------------------------- */
DropDownCircle.defaultProps = {
  color: 'transparent',
  style: {
    width: 25,
    height: 25
  }
}
/* --------------------------------------------- */
export default DropDownCircle
/* --------------------------------------------- */
